import { api, apiNoAuth } from '../../api';
import { AuthenticateRequest } from '../../model/account/authenticateRequest';
import { ForgotPasswordRequest } from '../../model/account/forgotPasswordRequest';
import { ResetPasswordRequest } from '../../model/account/resetPasswordRequest';
import { ValidateResetTokenRequest } from '../../model/account/validateResetTokenRequest';
import { VerifyEmailRequest } from '../../model/account/verifyEmailRequest';
import { SwitchAdminRequest } from '../../model/admin/switchAdminRequest';

export const accountService = {
  checkCredentials,
  verifyEmail,
  forgotPassword,
  validateResetToken,
  resetPassword,
  revokeToken,
  getAllHCPs,
  getAllPatients,
  switchAdmin,
  deleteAccount,
  enableTwoFactor,
  enableTwoFactorAdmin,
  disableTwoFactor,
  resetTwoFactor,
};

function checkCredentials(email: string, password: string) {
  const request: AuthenticateRequest = { email, password };
  return apiNoAuth.post('/accounts/check-credentials', request);
}

function verifyEmail(token: string) {
  const request: VerifyEmailRequest = { token };
  return apiNoAuth.post('/accounts/verify-email', request);
}

function forgotPassword(email: string) {
  const request: ForgotPasswordRequest = { email };
  return apiNoAuth.post('/accounts/forgot-password', request);
}

function validateResetToken(token: string) {
  const request: ValidateResetTokenRequest = { token };
  return apiNoAuth.post('/accounts/validate-reset-token', request);
}

function resetPassword(
  token: string,
  password: string,
  confirmPassword: string
) {
  const request: ResetPasswordRequest = {
    token,
    password,
    confirmPassword,
  };
  return apiNoAuth.post('/accounts/reset-password', request);
}

// This is essentially the "logout" method for this app
function revokeToken() {
  return api.post('/accounts/revoke-token').then((response: any) => {
    localStorage.removeItem('account');
    return response;
  });
}

function getAllHCPs() {
  return api.get('/admin/hcp-list');
}

function getAllPatients() {
  return api.get('/admin/patient-list');
}

function switchAdmin(emailAddress: string, isAdmin: boolean) {
  const request: SwitchAdminRequest = {
    emailAddress,
    isAdmin,
  };
  return api.post('/accounts/switch-admin', request);
}

function deleteAccount(accountGuid: string) {
  return api.post(`/accounts/delete/${accountGuid}`);
}

// Two Factor Authentication

function enableTwoFactor(accountGuid: string) {
  return api.post(`/accounts/enable-2fa/${accountGuid}?shouldSendEmail=false`);
}

function enableTwoFactorAdmin(accountGuid: string) {
  return api.post(`/accounts/enable-2fa-admin/${accountGuid}`);
}

function disableTwoFactor(accountGuid: string) {
  return api.post(`/accounts/disable-2fa/${accountGuid}`);
}

function resetTwoFactor(accountGuid: string) {
  return api.post(`/accounts/reset-2fa/${accountGuid}`);
}
